import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditGeneralUserComponent } from './components/edit-general-user/edit-general-user.component';
import { EditGeneralUsersComponent } from './components/edit-general-users/edit-general-users.component';
import { GeneralAdminComponent } from './components/general-admin/general-admin.component';
import { EditGeneralUserGroupsComponent } from './components/edit-general-user-groups/edit-general-user-groups.component';
import { EditGeneralUserGroupComponent } from './components/edit-general-user-group/edit-general-user-group.component';
import { AdminObjectListComponent } from './components/admin-object-list/admin-object-list.component';
import { AdminObjectEditComponent } from './components/admin-object-edit/admin-object-edit.component';

const routes: Routes = [
    {
        path: "admin",
        component: GeneralAdminComponent
    },
    {
        path: "admin/editGeneralUsers",
        component: EditGeneralUsersComponent
    },
    {
        path: "admin/editGeneralUser/:id",
        component: EditGeneralUserComponent
    },
    {
        path: "admin/editGeneralUserGroups",
        component: EditGeneralUserGroupsComponent
    },
    {
        path: "admin/editGeneralUserGroup/:id",
        component: EditGeneralUserGroupComponent
    },
    {
        path: "admin/generic-list/:scope/:id",
        component: AdminObjectListComponent
    },
    {
        path: "admin/generic-edit/:scope/:id/:key",
        component: AdminObjectEditComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SmBaseRoutingModule2 {
}
